import React, { Component } from "react";
import {
  Row,
  Col,
  Table,
  Modal,
  Image,
} from "react-bootstrap";

import "../Common/Common.css";
var dateFormat = require("dateformat");
class ProductReturnsView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const data =
      this.props.ProductReturnsDtls && this.props.ProductReturnsDtls.item
        ? this.props.ProductReturnsDtls && this.props.ProductReturnsDtls.item
        : null;

    const items = this.props.ProductReturnls
      ? this.props.ProductReturnls
      : null;
    // console.log("****itemitemitem***************", items);

    const hasMRP = items?.some(
      (item) => item.mrp !== undefined && item.mrp !== null,
    );

    const statusAllowsApprovedAmount = ["accepted", "created", "pending"].includes(
      data?.status,
    );
    const hasApprovedAmount = items?.some(
      (item) =>
        item?.approvedAmount !== undefined &&
        item?.approvedAmount !== null &&
        item?.approvedAmount !== "" &&
        Number(item?.approvedAmount) !== 0,
    );

    const totalClaimAmount = Array.isArray(items)
      ? items.reduce((sum, item) => sum + Number(item.claimAmount ?? 0), 0)
      : 0;

    const totalApprovedAmount = Array.isArray(items)
      ? items.reduce((sum, item) => {
          if (item.orderStatus === "approved") {
            return sum + Number(item.approvedAmount ?? 0);
          }
          return sum;
        }, 0)
      : 0;

    const hasPurchaseNotes =
      data?.prcpNotes && data.prcpNotes.trim().length > 0;

    const count =
      this.props.ProductReturnDtlsCount && this.props.ProductReturnDtlsCount;

    const displayValue = (value) =>
      value !== undefined && value !== null && value !== "" ? value : "-";
    const formatDate = (value) =>
      value ? dateFormat(value, "dd-mmm-yyyy") : "-";
    const getApprovedQuantity = (item) => {
      if (item?.orderStatus === "rejected") return 0;
      return item?.approvedQntty ?? item?.qntty ?? "-";
    };
    const getGstAmount = (item) => {
      const approvedQty =
        item?.orderStatus === "rejected"
          ? 0
          : Number(item?.approvedQntty ?? item?.qntty ?? 0);
      const price = Number(item?.price ?? 0);
      const taxPer = Number(item?.taxPercentage ?? 0);

      return ((approvedQty * price * taxPer) / 100).toFixed(2);
    };
    const apiTotalClaimAmount = Number(
      data?.totalClaimAmount ?? totalClaimAmount ?? 0,
    );
    const apiTotalApprovedAmount = Number(
      data?.totalApprovedAmount ?? totalApprovedAmount ?? 0,
    );
    return (
      <div>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
          size="lg"
          centered
          dialogClassName="product-return-view-modal"
          contentClassName="purchase-return-content"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>
              <span style={{ fontSize: "20px" }}>Product Return Details</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ fontSize: "15px" }}>
            <Row>
              <Col xs={12} sm={12} md={8} lg={8}>
                <h6>
                  Order No:{" "}
                  {data !== null && data.orderNo ? data.orderNo : null}|
                  <span className="cmn_Cap">
                    {data !== null && data.orderTrk ? data.orderTrk : null}{" "}
                    Order
                  </span>{" "}
                </h6>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <h6>
                  Status:{" "}
                  <span className="cmn_Cap">
                    {data !== null && data.status ? data.status : null}
                  </span>
                </h6>
              </Col>
            </Row>

            {data?.createdBy && data.createdBy.designation  && (
             <Row>
              <Col xs={12} sm={12} md={8} lg={8}>
                <h6>
                  Created By :{" "}
               
                  <span className="cmn_Cap">
                    {data !== null && data.createdBy && data.createdBy.fullName ? data.createdBy.fullName : null}
                  </span>{" "}
                </h6>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <h6>
                  Role :{" "}
                  <span className="cmn_Cap">
                    {data !== null && data.createdBy && data.createdBy.designation ? data.createdBy.designation : null}
                  </span>
                </h6>
              </Col>
            </Row>
            )}

            <hr />

            <Row>
              <Col xs={12} sm={12} md={4} lg={4}>
                <div>
                  <p className="boldClass">Order From:</p>
                  <p>
                    <span className="cmn_Cap">
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + " " + data.orderFrom.lName
                        : "---"}
                    </span>
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.orderFromName
                        ? data.orderFromName
                        : "---"}
                    </span>
                    <br />
                    {data !== null && data.orderFrom !== null && data.orderFrom
                      ? data.orderFrom.mobileNo
                      : "---"}
                    <br />
                    {data !== null && data.chmstDtls && data.chmstDtls.email
                      ? data.chmstDtls.email
                      : "---"}
                    <br />
                    {data !== null && data.chmstDtls && data.chmstDtls.website
                      ? data.chmstDtls.website
                      : "---"}
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.addr},
                      {data !== null && data.pincode}
                    </span>
                  </p>
                </div>
              </Col>

              <Col xs={12} sm={12} md={4} lg={4}></Col>

              <Col xs={12} sm={12} md={4} lg={4}>
                <div>
                  <p className="boldClass">Order To:</p>
                  <p>
                    <span className="cmn_Cap">
                      {data !== null && data.orderTo
                        ? data.orderTo.name + " " + data.orderTo.lName
                        : "---"}
                    </span>
                    <br />
                    <span className="cmn_Cap">
                      {data !== null && data.orderToName
                        ? data.orderToName
                        : "---"}
                    </span>
                    <br />
                    {data !== null && data.orderTo !== null && data.orderTo
                      ? data.orderTo.mobileNo
                      : "---"}
                    <br />
                    {data !== null && data.orderTo !== null && data.orderTo
                      ? data.orderTo.email
                      : "---"}
                    <br />
                    <span>
                      {data !== null && data.city ? data.city : "---"}
                    </span>
                    <br />
                    <span>
                      {data !== null &&
                        data.createdAt !== null &&
                        dateFormat(data.createdAt, "dd-mmm-yyyy, h:MM TT")}
                    </span>
                    <br />
                  </p>
                </div>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <h4>Item Details</h4>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}></Col>
              <Col xs={12} sm={12} md={3} lg={3}></Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <span className="cmnPageCount">
                    {" "}
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Items</span>
                </div>
              </Col>
            </Row>

            <Table responsive bordered className="cmnMainTable">
              <thead>
                <tr>
                  <th>Serial number (#)</th>
                  <th>
                    <div className="return-cell-pair">
                      <span>Item Name</span>
                      <span>Item Code</span>
                    </div>
                  </th>
                  <th>
                    <div className="return-cell-pair">
                      <span>Batch No</span>
                      <span>Purchase Invoice No</span>
                    </div>
                  </th>
                  <th>
                    <div className="return-cell-pair">
                      <span>Expiry Date</span>
                      <span>Purchase Date</span>
                    </div>
                  </th>
                   {hasMRP && <th>MRP</th>}
                  <th>Unit Price</th>
                  <th>Quantity</th>
                  <th>Approved Quantity</th>
                  <th>GST %</th>
                  <th>GST Amount</th>
                  <th>Offer/Scheme</th>
                  <th>Claim Amount</th>
                  {hasApprovedAmount && <th>Approved Amount</th>}
                  {data?.status !== "created" && <th>Status</th>}
                </tr>
              </thead>

              <tbody>
                {this.props.ProductReturnls &&
                  this.props.ProductReturnls.map((item, i) => (
                    <tr key={i}>
                      <td className="cmn_Cap">{i + 1}</td>
                      <td>
                        <div className="return-cell-pair return-cell-pair-body">
                          <span className="cmn_Cap">
                            {displayValue(item?.itemName ?? item?.itemCode?.drugName)}
                          </span>
                          <span>{displayValue(item?.itemCode?.drugCode)}</span>
                        </div>
                      </td>
                      <td className="cmn_Cap">
                        <div className="return-cell-pair return-cell-pair-body">
                          <span>{displayValue(item?.batchNo)}</span>
                          <span>{displayValue(item?.purchaseInvoiceNo)}</span>
                        </div>
                      </td>
                      <td className="cmn_Cap">
                        <div className="return-cell-pair return-cell-pair-body">
                          <span>{formatDate(item?.expiryDate)}</span>
                          <span>{formatDate(item?.purchaseDate)}</span>
                        </div>
                      </td>
                      {hasMRP && (
                        <td className="cmn_Cap">
                          {item?.mrp && Number(item.mrp) !== 0 ? item.mrp : "-"}
                        </td>
                      )}
                      <td>{displayValue(item?.price)}</td>
                      <td className="cmn_Cap">{displayValue(item?.qntty)}</td>
                      <td className="cmn_Cap">{getApprovedQuantity(item)}</td>
                      <td className="cmn_Cap">
                        {displayValue(item?.taxPercentage)}
                      </td>
                      <td className="cmn_Cap">{getGstAmount(item)}</td>
                      <td className="cmn_Cap">{displayValue(item?.offer)}</td>
                      <td className="cmn_Cap">
                        {displayValue(item?.claimAmountWithTax)}
                      </td>
                      {hasApprovedAmount && (
                        <td className="cmn_Cap">
                          {displayValue(item?.approvedAmount)}
                        </td>
                      )}
                      {data?.status !== "created" && (
                        <td className="cmn_Cap">
                          {displayValue(item?.orderStatus)}
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
            {/* TOTAL CLAIM AMOUNT */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "12px 10px",
                fontWeight: "bold",
                fontSize: "15px",
                borderTop: "1px solid #ddd",
                marginTop: "10px",
              }}
            >
              <span style={{ marginRight: "10px" }}>Total Claim Amount :</span>
              <span style={{ color: "#1768B7" }}>
                ₹ {apiTotalClaimAmount.toFixed(2)}
              </span>
            </div>

            {/* TOTAL APPROVED AMOUNT */}
            {statusAllowsApprovedAmount && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "12px 10px",
                  fontWeight: "bold",
                  fontSize: "15px",
                  borderTop: "1px solid #ddd",
                  marginTop: "10px",
                }}
              >
                <span style={{ marginRight: "10px" }}>
                  Total Approved Amount :
                </span>
                <span style={{ color: "#1768B7" }}>
                  ₹ {apiTotalApprovedAmount.toFixed(2)}
                </span>
              </div>
            )}

            {hasPurchaseNotes && (
              <div
                style={{
                  marginTop: "14px",
                  padding: "14px 16px",
                  backgroundColor: "#F5F9FF",
                  borderLeft: "4px solid #1768B7",
                  borderRadius: "6px",
                  fontSize: "14px",
                  color: "#333",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    marginBottom: "6px",
                    color: "#1768B7",
                  }}
                >
                  📝 Purchase Notes
                </div>

                <div style={{ lineHeight: "1.6" }}>{data.prcpNotes}</div>
              </div>
            )}

            {(this.props.ProductReturnls === undefined ||
              (this.props.ProductReturnls &&
                this.props.ProductReturnls.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Data Found</div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ProductReturnsView;
